import React, { Component, Fragment } from "react";
import FollowingList from "../../../golfers/components/Following";
import GolfersListItem from "./GolfersListItem";
import { Helmet } from "react-helmet";
import {
  H_CALC_FOLLOWING_TITLE,
  H_CALC_FOLLOWING_DESC,
} from "../../../../shared/variables/meta-seo";

export default class Following extends Component {
  renderItem = (golfer, key) => <GolfersListItem key={key} golfer={golfer} />;

  render() {
    const notFoundText = (
      <Fragment>
        <p>You are not following any golfers.</p>
        <br />
        <p>Golfers can be followed within the Golfer Lookup section.</p>
      </Fragment>
    );

    return (
      <Fragment>
        <Helmet>
          <title>{H_CALC_FOLLOWING_TITLE}</title>
          <meta name="description" content={H_CALC_FOLLOWING_DESC} />
        </Helmet>
        <FollowingList
          renderItem={this.renderItem}
          notFoundText={notFoundText}
          sortCriteria="last_name"
        />
      </Fragment>
    );
  }
}
